import { useMutation, useQueryClient } from 'react-query';

import { linkedEntitiesQueryKey } from 'src/Hooks/Queries/useFetchLinkedEntities';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { entityLinksApi } from 'src/Services/API';
import { LinkableEntityType } from 'src/Services/API/EntityLinks.api';

interface Variables {
  linkId: string;
  sourceType: LinkableEntityType;
  sourceId: string;
  otherType: LinkableEntityType;
  otherId: string;
}

const useDeleteEntityLink = () => {
  const assetId = useCurrentAssetId();
  const queryClient = useQueryClient();

  return useMutation<void, unknown, Variables>(
    async variables => {
      if (!assetId) throw new Error('No assetId provided');
      return entityLinksApi.remove(assetId, variables.linkId);
    },
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries(
          linkedEntitiesQueryKey(assetId, variables.sourceType, variables.sourceId)
        );
        queryClient.invalidateQueries(
          linkedEntitiesQueryKey(assetId, variables.otherType, variables.otherId)
        );
      },
    }
  );
};

export default useDeleteEntityLink;
